'use strict';

import { loadComponent } from "./utils/load-component";
import { uniqBy } from 'lodash';

loadComponent(
    'orchestra-ensemble',
    {
        props: [
            'defaultView',
            'peopleFeed',
            'instrumentsFeed',
        ],
        data: () => ({
            ViewModel: {
                Loading: true,
                View: '',
                Groups: [],
                Letter: false,
                People: [],
                UniquePeople: [],
            }
        }),
        mounted: function () {
            this.ViewModel.View = this.defaultView;
            Promise.all([
                this.getPeople(),
                this.getInstruments(),
            ]).finally(() => {
                this.ViewModel.Loading = false;
            });
        },
        methods: {
            getPeople: function () {
                return fetch(this.peopleFeed) // eslint-disable-line compat/compat
                    .then(res => res.json())
                    .then(people => {
                        this.ViewModel.People = people;
                        this.ViewModel.UniquePeople = uniqBy(people, 'Link');
                    });
            },
            getInstruments: function () {
                return fetch(this.instrumentsFeed) // eslint-disable-line compat/compat
                    .then(res => res.json())
                    .then(data => {
                        this.ViewModel.Groups = data;
                    });
            },


            setView: function (ViewModel, data) {
                ViewModel.View = data;
            },
            toggleInstrument: function (instrument) {
                instrument.Open = !instrument.Open;
            },
            getPeopleForInstrument: function (ViewModel, instrumentTitle) {
                let people = [];
                for (let person of ViewModel.People) {
                    if (person.Instrument === instrumentTitle) {
                        people.push(person);
                    }
                }
                return people;
            },
            getPeopleForAlpha: function (ViewModel, alpha) {
                let people = [];
                for (let person of ViewModel.UniquePeople) {
                    if (person.Alpha === alpha) {
                        people.push(person);
                    }
                }
                return people;
            },
            setAlpha: function (ViewModel, letter) {
                if (ViewModel.Letter === letter) {
                    ViewModel.Letter = false;
                } else {
                    ViewModel.Letter = letter;
                }
            },
            getAlpha: function getAlpha(ViewModel, ignoreLetter) {
                if (ViewModel.Letter && !ignoreLetter) {
                    return ViewModel.Letter;
                }


                return ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
            },
            getCloudinarySrc: function (image, height, width) {
                return image.replace(/\/f_auto\//, `/f_auto,c_fill,g_auto,w_${width},h_${height}/`);
            }
        }
    }
)
